/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Max_Players_NoneInputs */



/**
* | output |
* | --- |
* | "No cap" |
*
* @param {Tfield_Max_Players_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_max_players_none = /** @type {((inputs?: Tfield_Max_Players_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Max_Players_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de plafond")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin tope")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem teto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun tetto")
	return /** @type {LocalizedString} */ ("No cap")
});